module.exports = __webpack_public_path__ + "static/img/phone_ico_logo.6679967.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big_picture/phone_ico_logo.png
// module id = TX96
// module chunks = 0